import { Button, Table, Modal, message } from 'antd';

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import IconDelete from 'assets/images/IconDelete.svg';
import IconEdit from 'assets/images/IconEdit.svg';

//requests
import { getClass, deleteClassMembers } from 'requests/class';

//Components
import TableAction from 'components/TableAction';
import { useSelector } from 'react-redux';

const ClassListStudent = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [classData, setClassData] = useState();
    const [query, setQuery] = useState({
        page: 1,
        pageSize: 10,
    });

    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();
    const authUser = useSelector((state) => state.auth.authUser);

    const { confirm } = Modal;

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
        },
        {
            title: t('student_name'),
            dataIndex: 'name',
            render: (text, record) => (
                <div>
                    {authUser.role === 1 ? (
                        <Link to={`/students/${record.id}/edit`} className="nowrap">
                            {text}
                        </Link>
                    ) : (
                        <Link to={`/students/${record.id}/view`} className="nowrap">
                            {text}
                        </Link>
                    )}
                </div>
            ),
        },
        {
            title: t('email'),
            dataIndex: 'email',
        },

        {
            title: t('mobile'),
            dataIndex: 'mobile',
        },

        {
            title: t('action'),
            render: (text, record) => (
                <div className="nowrap">
                    {authUser?.role === 1 && (
                        <Link to={`/students/${record.id}/edit`} type="link">
                            <img src={IconEdit} alt="" />
                        </Link>
                    )}
                    <Button type="link" onClick={() => handleClickDeleteBtn(record.id)}>
                        <img src={IconDelete} alt="" />
                    </Button>
                </div>
            ),
        },
    ];

    useEffect(() => {
        getData();
    }, [location]);

    const getData = () => {
        getClass(params.id)
            .then((data) => {
                setClassData(data);
            })
            .catch((e) => {
                console.log(e);
                message.error(t(e.response?.data.message || 'error'));
            });
    };

    const handleClickDeleteBtn = (id) => {
        // modal confirm
        confirm({
            title: t('confirm_delete_one'),
            icon: <ExclamationCircleOutlined />,
            cancelText: t('cancel'),
            onOk() {
                handleDelete(id);
            },
        });
    };

    // delete single record
    const handleDelete = (id) => {
        deleteClassMembers(params.id, { memberIds: [id] })
            .then(() => {
                message.success(t('success'));
                getData();
            })
            .catch((e) => {
                console.log(e);
                message.error(t(e.response?.data.message || 'error'));
            });
    };

    const handleDeleteMany = async () => {
        deleteClassMembers(params.id, { memberIds: selectedRowKeys })
            .then(() => {
                message.success(t('success'));
                setSelectedRowKeys([]);
                getData();
            })
            .catch((e) => {
                console.log(e);
                message.error(t(e.response?.data.message || 'error'));
            });
    };

    const handleSearch = async (value) => {
        setQuery({
            ...query,
            search: value,
            page: 1,
        });
        return;
    };

    const handlePageChange = (page, pageSize) => {
        setSelectedRowKeys([]);

        setQuery({
            ...query,
            page,
            pageSize,
        });
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: setSelectedRowKeys,
    };

    let students = [];
    if (classData) {
        if (query.search) {
            students = classData.students.filter(
                (e) =>
                    (e.name && e.name.toLowerCase().indexOf(query.search.toLowerCase()) !== -1) ||
                    (e.email && e.email.toLowerCase().indexOf(query.search.toLowerCase()) !== -1) ||
                    (e.mobile && e.mobile?.toLowerCase().indexOf(query.search.toLowerCase()) !== -1),
            );
        } else {
            students = classData.students;
        }
    }

    return (
        classData && (
            <>
                <div className="header-panel">
                    <div className="class-info">
                        <div className="title">{classData.className}</div>
                        {authUser?.role === 1 && (
                            <div className="teacher">
                                {t('teacher_in_charge')}:{' '}
                                <span className="teacher-name">{classData.teachers[0]?.name}</span>
                            </div>
                        )}
                    </div>
                    <TableAction
                        query={query}
                        searchPlaceholder={t('search_student')}
                        onSearch={handleSearch}
                        onDelete={handleDeleteMany}
                        disableDeleteBtn={!selectedRowKeys.length}
                    />
                </div>
                <Table
                    rowKey="id"
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={students}
                    pagination={{
                        pageSize: query.pageSize,
                        total: students.length,
                        current: query.page,
                        showSizeChanger: true,
                        onChange: (page, pageSize) => handlePageChange(page, pageSize),
                    }}
                />
            </>
        )
    );
};

export default ClassListStudent;
